export enum Routes {
  HOW_TO_START_PLAYING = 'how_to_start_playing',
  FAQ = 'faq'
}
